export default __webpack_public_path__ + "static/media/01-zattera.194422b0.png";